import request from '@/utils/request'

/**
 * 资源列表
 * @param {*} data 
 * @returns 
 */
export const getResourceList = (data) =>  request({
    method: 'get',
    url: `/organization/api/resource/tree`,
    data: data
})

/**
 * 新增资源
 * @param {*} data 
 * @returns 
 */
 export const addResource = (data) =>  request({
    method: 'post',
    url: `/organization/api/resource/add`,
    data: data
})

/**
 * 删除资源
 * @param {*} data 
 * @returns 
 */
 export const deleteResource = (id) =>  request({
    method: 'delete',
    url: `/organization/api/resource/${id}`
})

/**
 * 修改资源
 * @param {*} data 
 * @returns 
 */
 export const updateResource = (data) =>  request({
    method: 'put',
    url: `/organization/api/resource/edit`,
    data: data
})

/**
 * 获取资源
 * @param {*} data 
 * @returns 
 */
 export const getResources = (data) =>  request({
    method: 'get',
    url: `/organization/api/resource/menu-tree`,
    data: data
})



